import { useEffect, useState } from "react";
import API from "../../../services/api";

export default function MessHoliday() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [hostels, setHostels] = useState([]);
  const [hostel, setHostel] = useState("");
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");

  // 🔹 Load hostels
  useEffect(() => {
    loadHostels();
  }, []);

  const loadHostels = async () => {
    const res = await API.get("/school-admin/hostels/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setHostels(res.data.hostels || []);
  };

  const addHoliday = async () => {
    if (!hostel || !date || !reason) {
      alert("Please select hostel, date and reason");
      return;
    }

    await API.post(
      "/school-admin/hostel/mess/holiday/",
      {
        hostel: Number(hostel),   // ✅ REQUIRED
        date,
        reason,
      },
      {
        headers: { "X-SCHOOL-ID": school.school.id },
      }
    );

    alert("✅ Mess holiday added & notifications sent");

    // reset
    setDate("");
    setReason("");
    setHostel("");
  };

  return (
    <div className="page">
      <h2>📢 Mess Holiday</h2>

      {/* HOSTEL */}
      <select value={hostel} onChange={(e) => setHostel(e.target.value)}>
        <option value="">Select Hostel</option>
        {hostels.map((h) => (
          <option key={h.id} value={h.id}>
            {h.name}
          </option>
        ))}
      </select>

      {/* DATE */}
      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
      />

      {/* REASON */}
      <input
        placeholder="Reason (eg. Kitchen maintenance)"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />

      <button onClick={addHoliday}>Add Holiday</button>
    </div>
  );
}